import type { Product, ProductBillOfMaterial } from '@ztechapps/common.contract'
import { quickClone } from '@ztechapps/common.utils'
import filter from 'lodash/filter'

export type BomSummary = {
  qtyNeededToBuild: number
  product: Product
  maxLevel?: number
}

/**
 * The BOM here is the one that is already computed, (e.g. computed by computeBomAsGreedy)
 * @param bom
 */
export function summarizeBom(bom: ProductBillOfMaterial[] = []) {
  //we don't want to mutate the product so we cloned it
  const bomClone = quickClone(bom)

  const flattenCount = new Map<string, BomSummary>()

  function travese(item: ProductBillOfMaterial, currentLevel = 0) {
    const itemProduct = item.product as Product

    // Use inventory if possible
    const currentValue = flattenCount.get(itemProduct._id)
    const newValue = (itemProduct?.requiredComputedQuantityOnHand ?? 0) + (currentValue?.qtyNeededToBuild ?? 0)
    flattenCount.set(itemProduct._id, {
      product: itemProduct,
      qtyNeededToBuild: newValue,
      maxLevel: currentLevel,
    })

    // we need to process it recursively
    const childBom: ProductBillOfMaterial[] = item?.product?.billOfMaterials ?? []
    if (childBom?.length) {
      for (const child of childBom) {
        travese(child, currentLevel + 1)
      }
    }
  }

  for (const bomItem of bomClone) {
    travese(bomItem)
  }

  //convert to array of object
  const bomSummaries: BomSummary[] = Array.from(flattenCount.entries()).map(
    ([, computeBomFlattenedResult]) => computeBomFlattenedResult
  )

  //remove hte zero entries
  const withQtyBomSummaryOnly = filter(bomSummaries, (x) => x.qtyNeededToBuild > 0)

  return withQtyBomSummaryOnly
}
